import { FormControl, FormGroup } from '@angular/forms';
import { AdminMultimediaImageUpload } from '@web/shared/module/multimedia';
import { AdminBrandBannerStatus } from '@web/shared/module/brand';
import { Guid, Nillable } from '@web/utils';

export class AdminBrandBannerDetailsForm {
  public constructor(
    private readonly data: {
      fileId: Guid;
      smallFileId?: Nillable<Guid>;
      status: AdminBrandBannerStatus;
      url?: Nillable<string>;
      visibilityEndDate?: Nillable<Date>;
      visibilityStartDate?: Nillable<Date>;
    },
  ) {}

  public get fileId(): Guid {
    return this.data.fileId;
  }

  public get smallFileId(): Nillable<Guid> {
    return this.data.smallFileId;
  }

  public get status(): AdminBrandBannerStatus {
    return this.data.status;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get visibilityStartDate(): Nillable<Date> {
    return this.data.visibilityStartDate;
  }

  public get visibilityEndDate(): Nillable<Date> {
    return this.data.visibilityEndDate;
  }
}

export type AdminBrandBannerDetailsFormControls = {
  url: FormControl<Nillable<string>>;
  file: FormControl<Nillable<AdminMultimediaImageUpload>>;
  smallFile: FormControl<Nillable<AdminMultimediaImageUpload>>;
  status: FormControl<Nillable<AdminBrandBannerStatus>>;
  visibilityStartDate: FormControl<Nillable<Date>>;
  visibilityEndDate: FormControl<Nillable<Date>>;
};

/* prettier-ignore */
export type AdminBrandBannerDetailsFormGroup = FormGroup<AdminBrandBannerDetailsFormControls>;
